import React from 'react';
import Icon from '../../ui/Icon';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  children: React.ReactNode;
}

const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, children }: ConfirmationModalProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg p-10 m-4 max-w-md w-full flex flex-col gap-4 shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center gap-3">
          <Icon name="Informative" width={28} height={28} fill="var(--ins-blue)" />
          <h3 className="text-xl font-semibold text-gray-900">{title}</h3>
        </div>

        <div className="text-sm text-gray-900">
          {children}
        </div>

        <div className="flex justify-end gap-3 mt-4">
          <button
            onClick={onClose}
            className="font-bold text-ins-blue bg-transparent border-none"
          >
            Manter meu horário
          </button>
          <button
            onClick={onConfirm}
            className="py-2.5 px-4 rounded-lg text-sm font-semibold text-white bg-ins-blue hover:bg-insHover-blue"
          >
            Reagendar meu horário
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;